/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', () => {
  const floatingPriceEl = document.querySelector('#floating-add-to-cart-price');

  const mainAtcBtn =
    document.querySelector('[data-add-to-cart]');

  if (!floatingPriceEl && !mainAtcBtn) return;

  function getMainPriceEl() {
    return (
      document.querySelector('[data-product-price] .money') ||
      document.querySelector('.product__price .money')
    );
  }

  function cleanCurrency(str) {
    return str.replace(/GBP/i, '').trim();
  }

  function syncPrice() {
    const mainPrice = getMainPriceEl();
    if (!mainPrice) return;

    const priceText = cleanCurrency(mainPrice.textContent);

    if (floatingPriceEl) {
      floatingPriceEl.textContent = priceText;
    }

    if (mainAtcBtn) {
      if (!mainAtcBtn.dataset.baseLabel) {
        mainAtcBtn.dataset.baseLabel = mainAtcBtn.textContent.split('–')[0].trim();
      }

      const baseLabel = mainAtcBtn.dataset.baseLabel;

      if (mainAtcBtn.disabled) return;

      mainAtcBtn.textContent = `${baseLabel} – ${priceText}`;
    }
  }

  requestAnimationFrame(syncPrice);

  const variantInputs = document.querySelectorAll(
    '[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]'
  );

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      requestAnimationFrame(syncPrice);
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.getElementById('floating-add-to-cart');

  if (addToCartButton) {
    console.log('Floating Add to Cart button found'); 

    addToCartButton.addEventListener('click', (event) => {
      event.preventDefault();

      console.log('Simulating main add-to-cart button click'); 
      
      const mainAddToCartButton = document.querySelector('[data-add-to-cart]');
      if (mainAddToCartButton) {
        mainAddToCartButton.click(); 
      } else {
        console.warn('Main add-to-cart button not found');
      }
    });
  } else {
    console.warn('Floating Add to Cart button not found');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const floatingButton = document.getElementById('floating-add-to-cart');
  const mainButton = document.querySelector('[data-add-to-cart]'); 
  const cartDrawer = document.querySelector('cart-drawer, .cart-drawer'); 

  if (!floatingButton || !mainButton) return;

  function toggleFloatingButton() {
    const mainButtonRect = mainButton.getBoundingClientRect();
    const isMainButtonOffScreen = mainButtonRect.bottom <= 0;
    const isCartOpen = cartDrawer && cartDrawer.classList.contains('is-open'); 

    if (isCartOpen || !isMainButtonOffScreen) {
      floatingButton.style.opacity = '0';
      floatingButton.style.pointerEvents = 'none';
      floatingButton.style.transform = 'translateY(100%)';
    } else {
      floatingButton.style.opacity = '1';
      floatingButton.style.pointerEvents = 'auto';
      floatingButton.style.transform = 'translateY(0)'; 
    }
  }

  toggleFloatingButton();
  window.addEventListener('scroll', toggleFloatingButton);


  const observer = new MutationObserver(toggleFloatingButton);
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
});

 

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
